import { useTranslation } from 'react-i18next';
import { SPACINGS } from 'shared/styles/variables';
import styled, { css } from 'styled-components';

import LoadingDocument from 'verify/components/LoadingDocument';
import ThemedParagraph from 'verify/components/ThemedParagraph';
import ThemedTitle from 'verify/components/ThemedTitle';
import { MIN_HEIGHTS } from 'verify/styles/variables';

export const TIMEOUT_INTERVAL = 20 * 1000;

// styled container to support processing view as overlay
const Container = styled('div')<{ asOverlay: boolean }>`
  ${(props) =>
    props.asOverlay &&
    css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `}
`;

const Header = styled('div')`
  min-height: ${MIN_HEIGHTS.header};
  margin-bottom: ${SPACINGS.base * 4}px;
`;

const AnimationContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  margin-top: ${SPACINGS.base * 8};
`;

interface VerifyDocumentsPendingViewProps {
  asOverlay?: boolean;
}

export default function VerifyDocumentsPendingView({
  asOverlay = false,
}: VerifyDocumentsPendingViewProps) {
  const [t] = useTranslation();

  return (
    <Container asOverlay={asOverlay}>
      {!asOverlay && (
        <Header>
          <ThemedTitle>{t('documents.pending.title')}</ThemedTitle>
          <ThemedParagraph>{t('documents.pending.description')}</ThemedParagraph>
        </Header>
      )}

      <AnimationContainer>
        <LoadingDocument icon='document' />
      </AnimationContainer>
    </Container>
  );
}
